import { Button, Card, CircularProgress, Divider, FormControl, Grid, InputLabel, MenuItem, Select, TextField, Typography } from "@mui/material";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router";
import Checkbox from "@mui/material/Checkbox";
import { green } from "@mui/material/colors";

import { Link } from "react-router-dom";
import "../style.css";
import { useParams } from "react-router";
import api from "../../../components/services/api";
import { Box } from "@mui/system";
import Swal from "sweetalert2";
import mime from "mime";
import { saveAs } from "file-saver";

export default function TallyDetail() {
  const [SalesOrderList, setSalesOrderList] = useState();
  const [ContainerList, setContainerList] = useState();
  const [data, setData] = useState();
  const [loading, setLoading] = useState(false);

  const [containeryard, setContaineryard] = useState([])

  let { Voyage } = useParams();
  const history = useHistory();

  //fetch Data

  const handleSubmit = async () => {
    const body = {
      voy: Voyage,
      ContainerList: ContainerList
    }
    const submit = async () => {
      const res = await api.post(`api/ship/detail/container/update`, body)
      if (res.meta.status) {
        Swal.fire({
          title: `${res.meta.message}`,
          icon: 'success',
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'OK'
        }).then((result) => {
          if (result.isConfirmed) {
            getData()
          }
        })
      }
    }
    submit()
  }

  const getData = async () => {
    const params = {
      voy: Voyage,
    };
    console.log(params);
    try {
      const res = await api.post("api/ship/detail/container/list", params);
      setSalesOrderList(res.data.SalesOrderList);
      setContainerList(res.data.ContainerList)
      setData(res.data)
      // data.data.map((x) => {
      //   setData(x);
      // });
    } catch (e) {
      console.log(e);
    }
  };

  const getContaineryard = async () => {
    const params = {
      voy: Voyage,
    };
    try {
      const res = await api.post("api/ship/containeryard/list", params);
      setContaineryard(res.data)

    } catch (e) {
      console.log(e);
    }
  };
  //api call
  useEffect(() => {
    // GET request using axios inside useEffect React hook
    getData();
    getContaineryard()

    // empty dependency array means this effect will only run once (like componentDidMount in classes)
  }, []);

  const getPDF = async () => {
    setLoading(true)

    await api.get(`api/report/empty-container-list/download?format=xlsx&voyNo=${Voyage}`, {
      responseType: "blob",
      timeout: 30000
    })
      .then((blobFile) => {
        const blobFileRes = new File([blobFile?.data], "test.xlsx", {
          type: mime.getType(".xlsx"),

        });

        // window.open(
        //   URL.createObjectURL(blobFileRes, "test.csv"),
        //   "_blank"
        // );
        saveAs(blobFileRes, "Report-empty-container-list.xlsx");
        setLoading(false)

      });
  }
  return (
    <div>
      <Card
        variant="outlined"
        style={{
          padding: "20px",
          margin: "25px",
          height: "86vh",
          maxHeight: "86vh",
          overflow: "auto",
        }}
      >
        {/* <h6 style={{ marginTop: "10px" }} className="textcolorgreen">
          แผนตารางเรือ
        </h6> */}

        <Grid container alignItems="center" spacing={1}>
          <Grid item xs>
            <Typography
              className="textcolordarkblue"
              variant="h5"
              component="h1"
            >
              Container TALLY
            </Typography>
          </Grid>
          <Grid item sx={{ display: "flex", flexDirection: "row" }}>
            <Typography className="textcolorBule">Ship </Typography>
            <Typography className="textcolorBule">
              <span>&nbsp;</span> / Ship Schedule
            </Typography>
            <Typography>
              <span>&nbsp;</span> /Container TALLY
            </Typography>
          </Grid>
        </Grid>

        <form>
          <Grid sx={{ padding: "40px 70px 40px 70px" }}>
            <Grid container alignItems="center" spacing={1}>
              <Grid
                item
                alignItems="center"
                xs={12}
                md={6}
                lg={8}
              // sx={{
              //   flexDirection: "rows",
              //   display: "flex",
              //   justifyContent: "space-around",
              // }}
              >
                <div>
                  <span className="textcolorBule">VOYAGE:</span>
                  <span style={{ margin: "0px 10px 0px 10px" }}>
                    {data?.Voyage}
                  </span>
                  <span className="textcolorBule"> BARGE:</span>
                  <span style={{ margin: "0px 10px 0px 10px" }}>
                    {" "}
                    {data?.BargeName}
                  </span>
                  <span className="textcolorBule">TUG:</span>
                  <span style={{ margin: "0px 10px 0px 10px" }}>
                    {data?.TugName}
                  </span>

                  <span className="textcolorBule">
                    TOTAL{" "}
                    <span style={{ color: "#000" }}>
                      {data?.TotalContainer}
                    </span>{" "}
                    Container
                  </span>
                </div>
                {/* <div> 
                  <span className="textcolorBule">ETD POL:</span>
                  <span style={{ margin: "0px 10px 0px 10px" }}>
                    {data?.ETDIn}
                  </span>
                  <span className="textcolorBule">CLOSING DATE:</span>
                  <span style={{ margin: "0px 10px 0px 10px" }}>
                    17/11/2020
                  </span>
                  <span className="textcolorBule">CLOSING TIME:</span>
                  <span style={{ margin: "0px 10px 0px 10px" }}>13.00 HRS</span>
                </div> */}
              </Grid>
              {/* <Grid
                item
                xs={12}
                md={6}
                lg={4}
                sx={{
                  display: "flex",
                  justifyContent: "end",
                }}
              >
                <Link
                  to={{
                    pathname: `/Ship/CyShip/${data?.Voyage}`,
                  }}
                >
                  <Button
                    sx={{ width: 100 }}
                    variant="contained"
                    style={{
                      background: "#80c340",
                      borderColor: "#80c340",
                      marginRight: "10px",
                    }}
                    InputProps={{
                      disableUnderline: true,
                    }}
                  // disabled={Submitting}
                  >
                    SHIP CY
                  </Button>
                </Link>
                <Link
                  to={{
                    pathname: `/Ship/CY/${data?.Voyage}`,
                  }}
                >
                  <Button
                    sx={{ width: 100 }}
                    variant="contained"
                    style={{
                      background: "#80c340",
                      borderColor: "#80c340",
                      marginRight: "10px",
                    }}
                  // disabled={Submitting}
                  >
                    CY
                  </Button>
                </Link>
                <Button
                  variant="outlined"
                  style={{ color: "#84BD5A", borderColor: "#84BD5A" }}

                // onClick={onClickEdit}
                >
                  <span className="material-icons-outlined">print</span>
                  พิมพ์เอกสาร
                </Button>
              </Grid> */}
            </Grid>

            <table
              style={{
                width: "100%",
                textAlign: "center",
                // border: "1px solid #e0e0e0",
                marginTop: 40,
              }}
            >
              <thead
                style={{
                  height: 50,
                  backgroundColor: "#30318D",
                  color: "white",
                }}
              >
                <tr>
                  <th>SO NO.</th>
                  <th>Customer/SHIPPER</th>
                  {/* <th>Carrier</th> */}
                  <th>BOOKING NO.</th>

                  <th>EtdPol </th>
                  <th>EtdCloseingDate</th>
                  <th>EtdCloseingTime</th>
                  <th>20</th>
                  <th>40</th>
                  {/* <th>40HQ"</th> */}
                  <th>Status</th>
                  {/* <th>STATUS</th> */}
                </tr>
              </thead>
              <tbody>
                {SalesOrderList?.map((x) => (
                  <tr>
                    <td style={{ padding: 5 }}>{x?.SoNumber}</td>
                    <td>{x?.CustomerName}</td>
                    {/* <td>BDSHA</td> */}
                    <td>{x?.ShippingBookingNo}</td>
                    <td>{moment(x?.EtdPol).format("DD/MM/yyy")}</td>
                    <td>{moment(x?.EtdCloseingDate).format("DD/MM/yyy")}</td>
                    <td>{x?.EtdCloseingTime}</td>
                    <td>{x?.Qty20}</td>
                    <td>{x?.Qty40}</td>
                    <td>
                      {x?.Status == "1" ? (
                        <Box
                          sx={{
                            backgroundColor: "blue",
                            color: "#fafafa",
                            borderRadius: "25px",
                          }}
                        >
                          New
                        </Box>
                      ) : x?.Status == "2" ? (
                        <Box
                          sx={{
                            backgroundColor: "#F39C12",
                            borderRadius: "25px",
                          }}
                        >
                          Process
                        </Box>
                      ) : x?.Status == "3" ? (
                        <Box
                          sx={{
                            backgroundColor: "#F39C12",
                            borderRadius: "25px",
                          }}
                        >
                          AssignToPlanner
                        </Box>
                      ) : x?.Status == "4" ? (
                        <Box
                          sx={{
                            backgroundColor: "#F39C12",
                            borderRadius: "25px",
                          }}
                        >
                          AssignToCy
                        </Box>
                      ) : x?.Status == "5" ? (
                        <Box
                          sx={{
                            backgroundColor: "#F39C12",
                            borderRadius: "25px",
                          }}
                        >
                          AssignToCy
                        </Box>
                      ) : x?.Status == "6" ? (
                        <Box
                          sx={{
                            backgroundColor: "#28A745",
                            borderRadius: "25px",
                          }}
                        >
                          Complete
                        </Box>
                      ) : (
                        ""
                      )}
                    </td>
                    {/* <td></td> */}
                    {/* <td>Process</td> */}
                  </tr>
                ))}
              </tbody>
            </table>
            <Divider sx={{ marginBottom: 5, marginTop: 5 }} />

            <table
              style={{
                width: "100%",
                textAlign: "center",
                // border: "1px solid #e0e0e0",
                marginTop: 40,
              }}
            >
              <thead
                style={{
                  height: 50,
                  backgroundColor: "#80C340",
                  color: "white",
                }}
              >
                <tr>
                  <th style={{ width: '3%' }}>  <Checkbox
                    size="small"
                    sx={{
                      color: '#fff',

                      "&.Mui-checked": {
                        color: '#fff',
                      },
                    }}
                    onChange={(e) => {
                      const select = ContainerList?.map((y) => {

                        y.isCheck = e.target.checked === true && y?.Status !== 0 ? true : false
                        return y
                      })

                      setContainerList([...select])

                    }}
                  // checked={Data?.selected || false}
                  /></th>
                  <th className="layoutTable" style={{ width: '10%' }}>VOY IN</th>
                  <th className="layoutTable3" style={{ width: '12%' }}>Container No.</th>
                  {/* <th className="layoutTable">CnCustomer/ShipperTR.</th> */}
                  {/* <th className="layoutTable2" style={{ width: '5%' }}>Carrier</th> */}
                  <th className="layoutTable2" style={{ width: '5%' }}>Size</th>
                  {/* <th className="layoutTable">BOGIE</th> */}
                  <th className="layoutTable" style={{ width: '15%' }}>Seal Shipper</th>
                  <th className="layoutTable" style={{ width: '15%' }}>Seal Shipper 2</th>
                  <th className="layoutTable" style={{ width: '15%' }}>Seal Carrier</th>
                  <th className="layoutTable" style={{ width: '5%' }}>VGMWeight</th>
                  <th className="layoutTable" style={{ width: '5%' }}>GRADE</th>

                  <th className="layoutTable" style={{ width: '5%' }}>BAY</th>
                  <th className="layoutTable" style={{ width: '5%' }}>ROW</th>
                  <th className="layoutTable" style={{ width: '5%' }}>TIER</th>
                </tr>
              </thead>
              <tbody>
                {ContainerList?.map((x, i) => (
                  <tr>
                    <td>
                      <Checkbox
                        size="small"
                        sx={{
                          color: green[500],
                          "&.Mui-checked": {
                            color: green[500],
                          },
                        }}
                        onChange={(e) => {
                          const select = ContainerList?.map((y) => {

                            y.isCheck = y?.ContainerId === x?.ContainerId ? e.target.checked === true ? true : false : y?.isCheck
                            return y
                          })

                          setContainerList([...select])

                        }}
                        checked={x?.isCheck ? true : false}
                        disabled={x?.Status === 0 ? true : false}
                      />
                    </td>
                    <td>{x?.VoyageIn}</td>

                    <td>{x?.ContainerId}</td>
                    <td>{x?.Size}</td>

                    <td>

                      {x?.Seal}
                    </td>
                    <td>

                      {x?.Seal_1}
                    </td>
                    <td>

                      {x?.Seal_2}
                    </td>
                    <td>
                      {x?.VGMWeight}
                    </td>
                    <td>

                      {x?.Grade}
                    </td>
                    {/* <td>{x?.Status == '0' ? (<Typography sx={{ color: '#F39C12', fontWeight: '600' }}>Process</Typography>) : ''}</td> */}

                    <td>
                      <TextField
                        size="small"
                        label='BAY'
                        // error={Boolean(touched.lastname)}
                        variant="outlined"
                        onKeyPress={(event) => {
                          if (!/[0-9]/.test(event.key)) {
                            event.preventDefault();
                          }
                        }}
                        inputProps={{
                          maxLength: 2,
                        }}
                        value={x?.Bay}
                        onChange={e => {
                          const select = ContainerList?.map((y) => {

                            y.Bay = y?.ContainerId === x?.ContainerId ? e.target.value : y?.Bay
                            return y
                          })

                          setContainerList([...select])
                        }}
                        disabled={!x?.isCheck}
                        sx={{ width: "100%", marginTop: '10px', marginBottom: '10px' }}
                      /></td>
                    <td>
                      <TextField
                        size="small"
                        label='ROW'
                        // error={Boolean(touched.lastname)}
                        variant="outlined"
                        onKeyPress={(event) => {
                          if (!/[0-9]/.test(event.key)) {
                            event.preventDefault();
                          }
                        }}
                        inputProps={{
                          maxLength: 2,
                        }}
                        value={x?.Row}
                        onChange={e => {
                          const select = ContainerList?.map((y) => {

                            y.Row = y?.ContainerId === x?.ContainerId ? e.target.value : y?.Row
                            return y
                          })

                          setContainerList([...select])
                        }}
                        disabled={!x?.isCheck}
                        sx={{ width: "100%", marginTop: '10px', marginBottom: '10px' }}
                      /></td>
                    <td>
                      <TextField
                        size="small"
                        label='TIER'
                        // error={Boolean(touched.lastname)}
                        variant="outlined"
                        onKeyPress={(event) => {
                          if (!/[0-9]/.test(event.key)) {
                            event.preventDefault();
                          }
                        }}
                        inputProps={{
                          maxLength: 2,
                        }}
                        value={x?.Tier}
                        onChange={e => {
                          const select = ContainerList?.map((y) => {

                            y.Tier = y?.ContainerId === x?.ContainerId ? e.target.value : y?.Tier
                            return y
                          })

                          setContainerList([...select])
                        }}
                        disabled={!x?.isCheck}
                        sx={{ width: "100%", marginTop: '10px', marginBottom: '10px' }}
                      /></td>


                  </tr>
                ))}
              </tbody>
            </table>

            <Grid item xs={8} sm={12} sx={{ marginTop: 5 }}>
              <Button
                sx={{ width: 80 }}
                type="button"
                variant="outlined"
                style={{
                  color: "#80c340",
                  borderColor: "#80c340",
                  marginRight: "10px",
                }}
                onClick={history.goBack}
              >
                Back
              </Button>
              <Button
                sx={{ width: 80 }}
                variant="contained"
                style={{
                  background: "#80c340",
                  borderColor: "#80c340",
                  marginRight: "10px",
                }}
                onClick={() => handleSubmit()}
              >
                Save
              </Button>
              <Button
                sx={{ width: 80 }}
                variant="contained"
                style={{
                  background: "#30318D",
                  borderColor: "#30318D",
                  marginRight: "10px",
                }}
                onClick={() => getPDF()}
              >
                {loading ? <CircularProgress size={22} color='inherit'/> : 'Print'}
              </Button>
            </Grid>
          </Grid>
        </form>
      </Card>
    </div>
  );
}
